/**
 * =============================================================================
 * IDS CRM Web - Customer status: Prospect, Active, Dormant
 * =============================================================================
 *
 * Client mirror of api/src/services/customerStatus.js — keep the two in step.
 * Chip rendering lives in components/CustomerStatusChip.js.
 *
 * Gareth 2026-09-14: customers, distributors and sites are Prospect, Active or
 * Dormant, and users set Status only. For an end customer the type follows it
 * (TYPE_FOR_STATUS); a distributor keeps its distributor type.
 *
 * =============================================================================
 */

export const CUSTOMER_STATUS_ORDER = ['prospect', 'active', 'dormant'];

export const CUSTOMER_STATUS_META = {
  prospect: { label: 'Prospect' },
  active: { label: 'Active' },
  dormant: { label: 'Dormant' }
};

/** The end-customer type each status carries. Distributors never go through this. */
export const TYPE_FOR_STATUS = { prospect: 'prospect', active: 'customer', dormant: 'former' };

const isCustomerStatus = (status) => CUSTOMER_STATUS_ORDER.includes(status);

export function customerStatusLabel(status) {
  return isCustomerStatus(status)
    ? CUSTOMER_STATUS_META[status].label
    : (status ? String(status).replace(/_/g, ' ') : 'Unknown');
}

/**
 * The status a new customer form starts on, from its link. A valid ?status=
 * wins. Otherwise the older ?type= links keep landing where they did: a
 * customer or a distributor starts Active, a former customer Dormant, and a
 * prospect (or no type at all) Prospect.
 */
export function initialStatusFromParams(statusParam, typeParam) {
  if (isCustomerStatus(statusParam)) return statusParam;
  if (typeParam === 'customer' || typeParam === 'distributor') return 'active';
  if (typeParam === 'former') return 'dormant';
  return 'prospect';
}

/**
 * '+ New Customer' from the End Customers list: Prospect from the Prospect tab,
 * otherwise Active. Nobody sets out to add a dormant customer, so the Dormant
 * tab starts Active too.
 */
export function newCustomerStatusForTab(tab) {
  return tab === 'prospect' ? 'prospect' : 'active';
}
